import React from 'react'
import { observer } from 'mobx-react'
import { SingleItemSelector } from 'admin/staffing/components/WorkspacePostingDialog/SingleItemSelector'
import Avatar from 'components/Avatar'
import Button from 'components/Button'
import { Form, FormGroupContainer, FormRow } from 'components/inputs'
import {
  ModalSheet,
  ModalSheetContent,
  ModalSheetContentDescription,
  ModalSheetContentTitle,
  ModalSheetFooter,
  ModalSheetFooterButtonGroup,
  ModalSheetFooterSpacer,
  ModalSheetHeader,
  ModalSheetSection,
} from 'components/ModalSheet'
import { AddCustomerToWorkspaceViewModel } from './AddCustomerToWorkspaceViewModel'

interface AddCustomerToWorkspaceDialogProps {
  vm: AddCustomerToWorkspaceViewModel
}

export const AddCustomerToWorkspaceDialog = observer(
  ({ vm }: AddCustomerToWorkspaceDialogProps) => {
    return (
      <ModalSheet
        showing={vm.showing}
        onRequestClose={vm.close}
        disableCloseOnOutsideClick
      >
        <ModalSheetHeader withCloseButton />

        <ModalSheetContent>
          <ModalSheetSection horizontallySpaced>
            <ModalSheetContentTitle>
              Add customer to workspace
            </ModalSheetContentTitle>
            <ModalSheetContentDescription compact>
              Select the workspace to add this customer to. A magic link
              invitation will be sent to their email address.
            </ModalSheetContentDescription>
          </ModalSheetSection>

          <ModalSheetSection spaced>
            <Form id="addCustomerToWorkspace" onSubmit={vm.submit}>
              <FormRow>
                <FormGroupContainer
                  label="Workspace"
                  error={vm.validation.getError('workspace')}
                >
                  <SingleItemSelector
                    model={vm.workspace}
                    itemOptions={vm.availableWorkspaces}
                    itemPrefix={(item) => (
                      <Avatar
                        subject={{
                          avatar: item?.branding.logos.icon,
                        }}
                        size={24}
                      />
                    )}
                    onChange={(value) =>
                      vm.setWorkspace(value === undefined ? null : value)
                    }
                    itemToString={(item) => (item ? item.name : '')}
                    placeholder="Select workspace"
                    disabled={vm.submit.pending}
                    dataTest="add-customer-to-workspace-workspace-selector"
                  />
                </FormGroupContainer>
              </FormRow>
            </Form>
          </ModalSheetSection>
        </ModalSheetContent>

        <ModalSheetFooter>
          <ModalSheetFooterSpacer />
          <ModalSheetFooterButtonGroup>
            <Button type="default" onClick={vm.close}>
              Cancel
            </Button>
            <Button
              submit
              form="addCustomerToWorkspace"
              type="primary"
              disabled={vm.submit.pending}
              dataTest="add-customer-to-workspace-submit"
            >
              Send Invitation
            </Button>
          </ModalSheetFooterButtonGroup>
        </ModalSheetFooter>
      </ModalSheet>
    )
  },
)
